import 'regenerator-runtime/runtime';
import { call, put } from 'redux-saga/effects';

import API, { methods, handleConflictResponses } from '../canvas-api';
import { handleGenericError } from '../common';
import { actions } from '../../reducers/printers/printers';

export default function* deleteStyles(action) {
  const { printerId, styleIds } = action.payload;
  try {
    const response = yield call(API, {
      method: methods.DELETE,
      path: `printers/${printerId}/styles`,
      body: { styleIds },
    });
    if (response === null) return;

    const deletedIds = response.success;
    yield put(actions.deleteStylesSuccess(printerId, deletedIds));

    handleConflictResponses(response.projectConflicts);
  } catch (e) {
    yield call(handleGenericError, action, e);
  }
}
